<template>
  <el-form
    size="medium"
    label-width="80px"
  >
    <el-form-item label="名称：">
      <el-input
        v-model="text"
        placeholder="请输入内容"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      text: '',
    };
  },
};
</script>

<style>

</style>
